import Vue from 'vue';
import moment from 'moment-timezone';

window.moment = moment;

Vue.filter('datetime', function (value, format = 'YYYY-MM-DD h:mm a z', timezone = null) {
  if (timezone) {
    return moment(value).tz(timezone).format(format);
  }
  return moment(value).format(format);
});
